import React from 'react';
import { Trophy } from 'lucide-react';
import { SITE } from '../mock';

// Sticky bottom call-to-action bar shown on phones/tablets only.
export default function MobileCTA() {
  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 px-3 py-3 flex items-center gap-3"
      style={{
        background: '#080B12',
        borderTop: '1px solid var(--ar-border)',
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))',
      }}
    >
      <a href={SITE.roobetRef} target="_blank" rel="noopener noreferrer" className="btn-cyan flex-[1.3] !py-3 !px-3 text-xs" data-testid="mobile-cta-open-roobet-btn">
        <img src="/assets/roobet-chip-navy.png" alt="" aria-hidden="true" className="h-5 w-5 object-contain" /> OPEN ROOBET
      </a>
      <a href="#leaderboard" className="btn-gold flex-1 !py-3 !px-3 text-xs" data-testid="mobile-cta-leaderboard-btn">
        <Trophy size={16} aria-hidden="true" /> LEADERBOARD
      </a>
    </div>
  );
}
